/* Site search. The search box (snippets/bs-search-overlay.liquid): opens from [data-bsx-open], Cmd/Ctrl+K or "/",
   traps focus, closes on Escape, the close button or the backdrop, and returns focus. While typing it asks Shopify's
   predictive search for sections/bs-search-suggest.liquid (debounced 120 ms, cached, stale replies dropped), adds the
   shortcuts and synonyms from Theme settings > BoostedSafe search, highlights the typed words and supports the
   ARIA combobox pattern (arrow keys, Enter). Recent searches live in localStorage. On /search
   (sections/bs-search.liquid) it adds the type tabs and remembers the search. Tracks nothing. */
(function () {
  'use strict';
  var RKEY = 'bsx-recent';
  var STOP = ' the for and can how what does with my an to of in on is it do you your will are best ';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return [].slice.call((el || document).querySelectorAll(sel)); }
  function lines(s) { return String(s || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[’']/g, '').replace(/-/g, '')
      .replace(/\b([a-z])\s+(\d{2,4})\b/g, '$1$2').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  /* ---------- recent searches ---------- */
  function recent() { try { var a = JSON.parse(localStorage.getItem(RKEY) || '[]'); return Array.isArray(a) ? a.slice(0, 6) : []; } catch (e) { return []; } }
  function remember(q) {
    q = String(q || '').trim(); if (q.length < 2 || q.length > 80) return;
    try { var a = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) {}
  }
  function forget() { try { localStorage.removeItem(RKEY); } catch (e) {} }

  /* ---------- shortcuts and synonyms (same rules as the Liquid on the search page) ---------- */
  function parseShortcuts(src) {
    return lines(src).map(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); });
      return { keys: (p[0] || '').split(',').map(norm).filter(function (k) { return k.length > 1; }), label: p[1], url: p[2], note: p[3] || '' };
    }).filter(function (x) { return x.label && x.url && x.keys.length; });
  }
  function parseSynonyms(src) {
    return lines(src).map(function (l) {
      var p = l.split('=>'); if (p.length < 2) return null;
      return { keys: p[0].split(',').map(norm).filter(Boolean), to: p[1].trim() };
    }).filter(function (x) { return x && x.to; });
  }
  function shortcutsFor(list, q, typing) {
    var n = norm(q), pad = ' ' + n + ' ', toks = n.split(' '), last = toks[toks.length - 1] || '', out = [], seen = {};
    var partial = typing && last.length >= 3 && STOP.indexOf(' ' + last + ' ') < 0;
    list.forEach(function (it) {
      if (out.length >= 3 || seen[it.url]) return;
      var hit = it.keys.some(function (k) { return pad.indexOf(' ' + k) > -1 || (partial && k.indexOf(' ') < 0 && k.indexOf(last) === 0); });
      if (hit) { seen[it.url] = 1; out.push(it); }
    });
    return out;
  }
  function expand(list, q) {
    var n = norm(q), pad = ' ' + n + ' ';
    for (var i = 0; i < list.length; i++) for (var j = 0; j < list[i].keys.length; j++) {
      var k = list[i].keys[j];
      if (pad.indexOf(' ' + k + ' ') > -1) return pad.replace(' ' + k + ' ', ' ' + list[i].to + ' ').trim();
    }
    return '';
  }

  /* wrap the typed words in <mark> where a word starts with them */
  function highlight(root, q) {
    var words = norm(q).split(' ').filter(function (w) { return w.length > 1; });
    if (!words.length) return;
    var re = new RegExp('(^|[^a-z0-9])(' + words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).sort(function (a, b) { return b.length - a.length; }).join('|') + ')', 'gi');
    $$('[data-bsx-hl]', root).forEach(function (el) {
      var text = el.textContent, out = '', last = 0, m;
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        var start = m.index + m[1].length;
        out += esc(text.slice(last, start)) + '<mark>' + esc(m[2]) + '</mark>';
        last = start + m[2].length;
        if (re.lastIndex === m.index) re.lastIndex++;
      }
      if (last) el.innerHTML = out + esc(text.slice(last));
    });
  }

  /* ---------- the search box ---------- */
  function initBox(root) {
    if (root.bsxBound) return;
    root.bsxBound = true;
    $$('body > [data-bsx]').forEach(function (old) { if (old !== root) old.remove(); });
    document.body.appendChild(root);   // out of the sticky header, above every other layer

    var cfg = {};
    try { cfg = JSON.parse($('[data-bsx-cfg]', root).textContent); } catch (e) {}
    var shortcuts = parseShortcuts(cfg.shortcuts), synonyms = parseSynonyms(cfg.synonyms);
    var panel = $('.bsx-panel', root), form = $('[data-bsx-form]', root), input = $('[data-bsx-input]', root);
    var clearBtn = $('[data-bsx-clear]', root), emptyView = $('[data-bsx-empty]', root), resView = $('[data-bsx-results]', root);
    var foot = $('[data-bsx-foot]', root), allLink = $('[data-bsx-all]', root), status = $('[data-bsx-status]', root);
    var noneTpl = $('[data-bsx-none]', root), famTpl = $('[data-bsx-fams]', root);
    var cache = {}, seq = 0, timer = 0, ctrl = null, active = -1, lastFocus = null, current = '';

    function view() { return resView.hidden ? emptyView : resView; }
    function options() { return $$('[data-bsx-opt]', view()).filter(visible); }
    function setActive(i) {
      var opts = options();
      opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      active = i;
      if (i < 0 || !opts[i]) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
      opts[i].classList.add('is-active'); opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      opts[i].scrollIntoView({ block: 'nearest' });
    }
    function numberOptions(el, prefix) { $$('[data-bsx-opt]', el).forEach(function (o, i) { o.id = prefix + i; o.setAttribute('aria-selected', 'false'); }); }

    function renderRecent() {
      var box = $('[data-bsx-recent]', root), list = $('[data-bsx-recent-list]', root), r = recent();
      list.textContent = '';
      r.forEach(function (q) {
        var a = document.createElement('a');
        a.className = 'bsx-chip'; a.href = (cfg.search || '/search') + '?q=' + encodeURIComponent(q);
        a.setAttribute('data-q', q); a.setAttribute('role', 'option'); a.setAttribute('tabindex', '-1'); a.setAttribute('data-bsx-opt', '');
        a.innerHTML = '<svg class="bs-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
        a.appendChild(document.createTextNode(q));
        list.appendChild(a);
      });
      box.hidden = !r.length;
      numberOptions(emptyView, 'bsx-e');
    }

    function showEmpty() {
      seq++; if (ctrl) ctrl.abort();
      root.classList.remove('is-loading');
      resView.hidden = true; resView.textContent = ''; emptyView.hidden = false; foot.hidden = true;
      input.setAttribute('aria-controls', 'bsx-list'); current = '';
      renderRecent(); setActive(-1);
    }

    function url(q) {
      return (cfg.suggest || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(cfg.section || 'bs-search-suggest') +
        '&resources[type]=product,page,article,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    }
    function get(q) {
      var key = q.toLowerCase();
      if (cache[key]) return Promise.resolve(cache[key]);
      return fetch(url(q), ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
        if (!r.ok) throw new Error('search ' + r.status);
        return r.text();
      }).then(function (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bsx-res]');
        if (!node) throw new Error('search: no results block');
        var d = { node: node, exact: node.getAttribute('data-exact') === '1', n: +node.getAttribute('data-n') || 0, products: +node.getAttribute('data-products') || 0 };
        cache[key] = d;
        return d;
      });
    }

    function shortcutGroup(list) {
      var g = document.createElement('div');
      g.className = 'bsx-g'; g.setAttribute('role', 'group'); g.setAttribute('aria-labelledby', 'bsx-gh-jump');
      g.innerHTML = '<h3 class="bsx-gh" id="bsx-gh-jump">Jump to</h3><div class="bsx-hits">' + list.map(function (it) {
        return '<a class="bsx-row bsx-hit" href="' + esc(it.url) + '" role="option" tabindex="-1" data-bsx-opt>' +
          '<span class="bsx-ic" aria-hidden="true"><svg class="bs-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg></span>' +
          '<span class="bsx-rb"><span class="bsx-t">' + esc(it.label) + '</span>' + (it.note ? '<span class="bsx-sub">' + esc(it.note) + '</span>' : '') + '</span></a>';
      }).join('') + '</div>';
      return g;
    }

    function render(q, d, used) {
      var hits = shortcutsFor(shortcuts, q, true);
      var exact = !!(d && d.exact), any = !!(d && d.n);
      var frag = document.createDocumentFragment(), count = 0;
      if (exact || (hits.length && any)) {
        if (used.toLowerCase() !== q.toLowerCase()) {
          var note = document.createElement('p'); note.className = 'bsx-note';
          note.innerHTML = 'No exact match for “' + esc(q) + '”, so here is <b>' + esc(used) + '</b>.';
          frag.appendChild(note);
        }
        var res = d.node.cloneNode(true), colA = $('[data-bsx-col-a]', res), colB = $('[data-bsx-col-b]', res);
        if (hits.length) colA.insertBefore(shortcutGroup(hits), colA.firstChild);
        if (!colA.children.length || !colB.children.length) $('.bsx-cols', res).classList.add('is-one');
        frag.appendChild(res);
        count = d.n + hits.length;
      } else if (hits.length) {
        frag.appendChild(shortcutGroup(hits));
        var g = document.createElement('div'); g.className = 'bsx-g';
        g.innerHTML = '<h3 class="bsx-gh">Shop by safe</h3>';
        g.appendChild(famTpl.content.cloneNode(true));
        frag.appendChild(g);
        count = hits.length;
      } else {
        var none = noneTpl.content.cloneNode(true);
        $('[data-bsx-qtext]', none).textContent = q;
        frag.appendChild(none);
      }
      resView.textContent = '';
      resView.appendChild(frag);
      highlight(resView, used);
      numberOptions(resView, 'bsx-r');
      emptyView.hidden = true; resView.hidden = false; foot.hidden = false;
      input.setAttribute('aria-controls', 'bsx-list-r');
      allLink.href = (cfg.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      allLink.innerHTML = '<span>See all results for “' + esc(q.length > 28 ? q.slice(0, 27) + '…' : q) + '”</span>';
      status.textContent = count ? count + (count === 1 ? ' suggestion' : ' suggestions') + ' for ' + q : 'No exact match for ' + q;
      resView.scrollTop = 0; $('[data-bsx-body]', root).scrollTop = 0;
      setActive(-1);
    }

    function run(q) {
      var my = ++seq;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      root.classList.add('is-loading');
      get(q).then(function (d) {
        if (d.exact) return { d: d, used: q };
        var q2 = expand(synonyms, q);
        if (!q2 || q2.toLowerCase() === q.toLowerCase()) return { d: d, used: q };
        return get(q2).then(function (d2) { return d2.exact ? { d: d2, used: q2 } : { d: d, used: q }; }, function () { return { d: d, used: q }; });
      }).then(function (r) {
        if (my !== seq) return;
        root.classList.remove('is-loading');
        render(q, r.d, r.used);
      }, function (e) {
        if (my !== seq || (e && e.name === 'AbortError')) return;
        root.classList.remove('is-loading');
        render(q, null, q);
      });
    }

    function onInput() {
      var q = input.value.replace(/\s+/g, ' ').trim();
      clearBtn.hidden = !input.value;
      clearTimeout(timer);
      if (!q) { showEmpty(); return; }
      if (q === current) return;
      current = q;
      timer = setTimeout(function () { run(q); }, 120);
    }
    function setQuery(q) { input.value = q; input.focus(); current = ''; clearTimeout(timer); clearBtn.hidden = false; current = q; run(q); }

    function activate(el) {
      if (el.hasAttribute('data-bsx-forget')) { forget(); renderRecent(); setActive(-1); input.focus(); return; }
      if (el.hasAttribute('data-q') && el.closest('.bsx')) { setQuery(el.getAttribute('data-q')); return; }
      if (current) remember(current);
      if (el.href) window.location.href = el.href;
    }

    function trap(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var items = $$('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([type="hidden"])', panel).filter(visible);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }

    function open(from) {
      if (!root.hidden) { input.focus(); return; }
      lastFocus = from || document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('bsx-lock');
      $$('[data-bsx-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (!input.value.trim()) showEmpty(); else renderRecent();
      input.focus();
      try { input.select(); } catch (e) {}
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.addEventListener('keydown', trap, true);
    }
    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('bsx-lock');
      document.removeEventListener('keydown', trap, true);
      $$('[data-bsx-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var back = lastFocus && document.contains(lastFocus) && visible(lastFocus) ? lastFocus : $$('[data-bsx-open]').filter(visible)[0];
      if (back) back.focus();
    }
    root.bsxOpen = open;

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(opts.length ? (active + 1) % opts.length : -1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(opts.length ? (active <= 0 ? opts.length - 1 : active - 1) : -1); }
      else if (e.key === 'Enter') {
        if (active > -1 && opts[active]) { e.preventDefault(); activate(opts[active]); }
        else if (!input.value.trim()) e.preventDefault();
      }
    });
    form.addEventListener('submit', function () { remember(input.value); });
    clearBtn.addEventListener('click', function () { input.value = ''; showEmpty(); clearBtn.hidden = true; input.focus(); });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bsx-close], [data-bsx-forget], [data-q], a[href]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bsx-close')) { e.preventDefault(); close(); return; }
      if (t.hasAttribute('data-bsx-forget') || t.hasAttribute('data-q')) { e.preventDefault(); activate(t); return; }
      if (t.hasAttribute('data-bsx-all')) { remember(input.value); return; }
      if (current) remember(current);
    });
    root.addEventListener('mousemove', function (e) {
      var o = e.target.closest('[data-bsx-opt]');
      if (!o || o.classList.contains('is-active') || active < 0) return;
      setActive(options().indexOf(o));
    });
  }

  function box() { return $('body > [data-bsx]') || $('[data-bsx]'); }
  function boot(scope) {
    var r = $('[data-bsx]', scope);
    if (r) initBox(r);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bsx-open]');
    if (!b) return;
    e.preventDefault();
    var r = box(); if (!r) return;
    if (!r.bsxBound) initBox(r);
    var from = b;
    var menu = b.closest('[data-bs-menu]');
    if (menu) {   // the phone menu's search field: close the menu first, then hand focus back to the menu button later
      var x = $('[data-bs-menu-close]', menu); if (x) x.click();
      from = $('[data-bs-menu-toggle]') || document.activeElement;
    }
    r.bsxOpen(from);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target, typing = t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
    var k = (e.key || '').toLowerCase();
    if ((e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && k === 'k') {
      var r = box(); if (!r) return;
      e.preventDefault();
      if (!r.bsxBound) initBox(r);
      r.bsxOpen(t);
    } else if (k === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey) {
      var r2 = box(); if (!r2 || !r2.hidden) return;
      e.preventDefault();
      if (!r2.bsxBound) initBox(r2);
      r2.bsxOpen(t);
    }
  });

  /* ---------- the search page ---------- */
  function initPage(page) {
    if (page.bsxBound) return;
    page.bsxBound = true;
    var params = new URLSearchParams(location.search);
    var from = params.get('bsx_from'), q = params.get('q');
    if (q) remember(from || q);
    var fromEl = $('[data-bsx-from]', page);
    if (from && fromEl) { $('b', fromEl).textContent = from; fromEl.hidden = false; }
    var tabs = $$('[data-bsx-tab]', page), groups = $('[data-bsx-groups]', page);
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var which = t.getAttribute('data-bsx-tab');
        tabs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        if (groups) groups.setAttribute('data-show', which);
      });
    });
  }

  function scan(scope) {
    boot(scope);
    $$('[data-bsx-page]', scope).forEach(initPage);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
